import { API_BASE_URL } from './AppConstants';
import { PasswordRefFilterState } from '../types/resources/State';

export const CERTIFICATES_URL = `${API_BASE_URL}certificates`;

export const LCOPS_BASE_URL = '/lcm/lcops';

export const GET_ALIASES_URL = (type: string) =>
  `${API_BASE_URL}${type}/list/aliases`;

export const GET_CERTIFICATES_URL = (
  currentPage: number,
  pageSize: number,
  filter: string
) =>
  `${API_BASE_URL}certificates/search?from=${currentPage}&size=${pageSize}&aliasQuery=${filter}`;

export const GET_CERTIFICATE_DETAIL_URL = (VMID: string) =>
  `${API_BASE_URL}certificates/detail/${VMID}`;

export const GET_RESOURCE_REFERENCES_URL = (VMID: string) =>
  `${API_BASE_URL}references/${VMID}`;

export const REPLACE_CERTIFICATE_URL = (VMID: string) =>
  `${API_BASE_URL}certificates/replace/${VMID}`;

export const REPLACE_CERTIFICATE_PRE_CHECK_URL = (VMID: string) =>
  `${API_BASE_URL}certificates/replace/prevalidate/${VMID}`;

export const ADD_CERTIFICATE_URL = `${API_BASE_URL}v2/certificates`;

export const GET_CERTIFICATE_BY_ALIAS = (alias: string) =>
  `${API_BASE_URL}certificates/getBy?alias=${alias}`;

export const VALIDATE_CERTIFICATE_URL = `${API_BASE_URL}certificates/validate`;

export const IMPORT_ALLOCATION_FILE_URL = `${API_BASE_URL}licenses/importAllocation`;

export const DELETE_CERTIFICATE_URL = (certificateID: string) =>
  `${API_BASE_URL}certificates/${certificateID}`;

export const DOWNLOAD_CERTIFICATE_URL = (alias: string) =>
  `${API_BASE_URL}certificates/${alias}/download/`;

export const GENERATE_CSR_URL = `${API_BASE_URL}certificates/csr`;

export const LICENSES_URL = `${API_BASE_URL}licenses`;

export const AVAILABLE_LICENSES_URL = `${API_BASE_URL}active/licenses`;

export const GENERATE_LICENSE_URL = (licenseId: string) =>
  `${API_BASE_URL}licenses/usage/${licenseId}`;

export const VRCSM_BILLING_DATE = (licenseId: string) =>
  `${API_BASE_URL}licenses/usage/uploaded/vrcsm/date/${licenseId}`;

export const DOWNLOAD_BILLING_REPORT = (licenseId: string, mask: boolean) =>
  `${API_BASE_URL}licenses/usage/vrcsm/download/${licenseId}?mask=${mask}`;

export const LICENSE_VALIDATE_URL = `${API_BASE_URL}license/validate`;

export const SUBSCRIPTION_MANAGER_KEY_URL = `${API_BASE_URL}licenses/usage/code/vrcsm`;

export const UPDATE_LICENSE_URL = (vmid: string) =>
  `${API_BASE_URL}licenses/${vmid}`;

export const DELETE_LICENSE_URL = (VMID: string) =>
  `${API_BASE_URL}licenses/${VMID}`;

export const GET_LICENSE_DETAIL_URL = (VMID: string) =>
  `${API_BASE_URL}licenses/detail/${VMID}`;

export const SYNC_USAGE = (VMID: string) =>
  `${API_BASE_URL}licenses/usage/${VMID}`;

export const MY_VMWARE_ACCOUNT_URL = `${LCOPS_BASE_URL}/api/settings/myvmwaresetting`;

export const PASSWORDS_URL = `${API_BASE_URL}passwords`;

export const GET_PASSWORDS_URL = (
  currentPage: number,
  pageSize: number,
  filter: string
) =>
  `${API_BASE_URL}passwords/search?from=${currentPage}&size=${pageSize}&aliasQuery=${filter}`;

export const DELETE_PASSWORD_URL = (passwordID: string) =>
  `${API_BASE_URL}passwords/${passwordID}`;

export const COPY_PASSWORD_URL = (passwordID: string) =>
  `${API_BASE_URL}passwords/${passwordID}`;

export const UPDATE_PASSWORD_URL = (passwordID: string) =>
  `${API_BASE_URL}passwords/${passwordID}`;

export const GET_PASSWORD_DETAIL_URL = (VMID: string) =>
  `${API_BASE_URL}passwords/detail/${VMID}`;

export const GET_REFERENCES_URL = (VMID: string) =>
  `${API_BASE_URL}references/ungrouped/${VMID}`;

export const GET_PASSWORD_REFERENCE_URL = (
  VMID: string,
  currentPage: number,
  pageSize: number,
  type: string,
  filters: PasswordRefFilterState | undefined
) => {
  let filterQueries = '';
  let typeQueries = '';

  if (filters) {
    if (filters.typeQuery.length > 0) {
      type = filters.typeQuery;
      filters.typeQuery = '';
    }
    const finalFilters: string[] = [];
    filterQueries = Object.keys(filters)
      .reduce((acc, f) => {
        if (filters[f] !== '') {
          const query = `${f}=${filters[f]}`;
          acc.push(query);
        }
        return acc;
      }, finalFilters)
      .join('&');
  }

  if (type.includes(',')) {
    let splitAr = type.split(',').map(itm => `typeQuery=${itm}`);
    typeQueries = splitAr.join('&');
  } else {
    typeQueries = `typeQuery=${type}`;
  }

  // eslint-disable-next-line max-len
  return `${API_BASE_URL}references/ungrouped/${VMID}?size=${pageSize}&from=${currentPage}&${typeQueries}&${filterQueries}`;
};

export const SUBMIT_PRODUCT_ACTION_URL = (
  environmentId: string,
  productId: string,
  action: string
) =>
  `${LCOPS_BASE_URL}/api/environments/${environmentId}/products/${productId}/${action}`;

export const GET_PASSWORD_ALIASES_URL = `${API_BASE_URL}passwords/list/vmids`;

export const UPDATE_NODE_PASSWORD_URL = (
  environmentId: string,
  productId: string,
  nodeType: string
) =>
  `${LCOPS_BASE_URL}/api/environments/${environmentId}/products/${productId}/node/${nodeType}`;

export const UPDATE_VIDM_NODE_SSHUSER_PASSWORD_URL = (
  environmentId: string,
  productId: string,
  nodeType: string
) =>
  // eslint-disable-next-line max-len
  `${LCOPS_BASE_URL}/api/environments/${environmentId}/products/${productId}/node/${nodeType}/vidm/updatevidmsshuserpassword`;

export const UPDATE_VIDM_NODE_ADMIN_PASSWORD_URL = (
  environmentId: string,
  productId: string,
  nodeType: string
) =>
  `${UPDATE_NODE_PASSWORD_URL(
    environmentId,
    productId,
    nodeType
  )}/vidm/updatevidmsystemadminpassword`;

export const UPDATE_VIDM_CONFIG_ADMIN_PASSWORD_URL = (
  environmentId: string,
  productId: string
) =>
  `${LCOPS_BASE_URL}/api/environments/id/${environmentId}/${productId}/updateConfigAdminPassword`;

export const GET_REQUESTS_URL = `/lcm/request/api/requests`;

export const LICENSE_REFRESH_URL = `${API_BASE_URL}licenses/refresh`;

export const VIEW_PASSWORD_URL = (vmid: string) =>
  `${API_BASE_URL}passwords/view/${vmid}`;
